import React, {Component} from "react";
import classNames from 'classnames';
import Tools from "../../../Tools";

class TabsBase extends Component {
    /**
     * Renders Tabs component.
     * @returns {React.ReactNode} The Tabs component.
     */
    render = () => {
        const classes = this.props.className;
        const customClasses = this.customClasses();
        return (
            <div className={classNames(classes, customClasses)}>
                {this.renderContent()}
            </div>
        );
    };

    /**
     * Returns the items of tab controller.
     * @returns {React.ReactNode} The tab controller items.
     */
    items = () => this.props.items;

    /**
     * Returns the keys of items of tab controller.
     * @returns {React.ReactNode} The tab controller items keys.
     */
    keys = () => this.items().map(item => item.key);
    /**
     * Returns the default key of tab controller.
     * @returns {React.ReactNode} The default item key.
     */
    defaultKey = () => this.keys()[0];
    /**
     * Returns the id of vertical tab component.
     * @returns {React.ReactNode} The component id.
     */
    customId = () => this.props.id ?? Tools.generateToken(16);
    /**
     * Returns the custom classes of vertical tab component.
     * @returns {React.ReactNode} The custom classes.
     */
    customClasses = () => '';
}

TabsBase.createItem = (header, content, key) => ({
    key: key ?? Tools.generateToken(16),
    header: header,
    content: content,
});

export default TabsBase;
